import axios from "axios";
// need to change everything to match FIFA backend

const API_DETAILS = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  baseApiKey: process.env.REACT_APP_BASE_API_KEY,
};

const getTimeZone = () => {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  const minutes = offset % 60;
  const hours = Math.floor(offset / 60);

  return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
};

const padTo2Digits = (num) => num.toString().padStart(2, "0");

const getLocalLanguage = () => {
  const userLocale =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;

  const language = userLocale.split("-")[0];
  return language;
};

export const getURL = (video = false) => {
  const language = getLocalLanguage();

  const Axios = axios.create({
    baseURL:  API_DETAILS.baseUrl
  });
  const apiKey = API_DETAILS.baseApiKey

  Axios.defaults.headers.common["Content-Type"] = video
    ? "multipart/form-data"
    : "application/json";
  Axios.defaults.headers.common["X-Custom-Language"] = language;
  // Axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
  // Axios.defaults.headers.common["X-Custom-Timezone"] = timezone;
  Axios.defaults.headers.common["Authorization"] = `Bearer ${apiKey}`;

  return Axios;
};

export const getBaseURL = (video = false) => {
  const language = getLocalLanguage();
  const Axios = axios.create(API_DETAILS.baseUrl);

  Axios.defaults.headers.common["Content-Type"] =
    "multipart/form-data; boundary=form-data-ApKiywFYpCtdpqEo";
  Axios.defaults.headers.common["X-Custom-Language"] = language;
  Axios.defaults.headers.common["Authorization"] =
    "Bearer 678e22bdb7d12c297cba77089950d84d";

  return Axios;
};

export const setHeadersAndParameters = (
  params,
  signal = false,
  video = false
) => {
  const accessToken = sessionStorage.getItem("auth");
  const timezone = getTimeZone();
  const language = getLocalLanguage();
    const apiKey = "678e22bdb7d12c297cba77089950d84d";
  const headersWithParams = {
    headers: {
      "Content-Type": video ? "multipart/form-data" : "application/json",
      "X-Custom-Format": "html",
      "X-Custom-Language": language,
      "X-Custom-Timezone": timezone,
      Authorization: `Bearer ${apiKey}.${accessToken}`,
    },
    params: params.params,
    signal: signal,
  };

  return headersWithParams;
};

export const setImageHeaders = () => {
  const accessToken = sessionStorage.getItem("auth");
  const timezone = getTimeZone();
  const language = getLocalLanguage();
  const apiKey = "678e22bdb7d12c297cba77089950d84d";

  const headers = {
    headers: {
      "X-Custom-Format": "html",
      "X-Custom-Language": language,
      "X-Custom-Timezone": timezone,
      Authorization: `Bearer ${apiKey}.${accessToken}`,
    },
  };

  return headers;
};

export const setHeaders = (video = false) => {
  const accessToken = sessionStorage.getItem("auth");
  const timezone = getTimeZone();
  const language = getLocalLanguage();
    const apiKey = API_DETAILS.baseApiKey;
  const headers = {
    headers: {
      "Content-Type": video ? "multipart/form-data" : "application/json",
      "X-Custom-Format": "html",
      "X-Custom-Language": language,
      "X-Custom-Timezone": timezone,
      // "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${apiKey}.${accessToken}`,
    },
  };
  return headers;
};
